// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_Has","cls2":"FriendlySutdModal-cls2_cMN FriendlySutdModal-cls1_Has"};